import query from "../../../../../../server/constants.api";
import useFetch from "../../../../../../server/useFetch";
import { findPropertiesByType, getListOfMandatoryAndOptionalProperties, mandatoryFirstProperties, prioritizeMandatoryProperties } from "../ItemsConfig/ItemsConfig";
import ItemCreate from "./ItemCreate/ItemCreate";
import ItemEdit from "./ItemEdit/ItemEdit";

const ItemCreateEdit = ({ isCreateModalOpen, isEditModalOpen, onCreateModalClose, onEditModalClose, itemToEdit, onCreationSuccess }) => {

    const {
        data: itemFullProperties,
        isFetching: isFetchingItemFullProperties,
        refetch: refetchItemFullProperties
    } = useFetch('/items/properties',
        'getItemFullProperties',
        {
            "full-properties": true,
        },
        true,
        null,
        query.middlewareURL);

    /**
     * Serialize the record to be used in the create/edit modal
     * @returns 
    */
    const serializeRecordForCreate = () => {
        if (!itemFullProperties || !isCreateModalOpen) return null;
        const baseProperties = findPropertiesByType("Base", itemFullProperties);
        const transformedBaseProperties = getListOfMandatoryAndOptionalProperties([baseProperties], ["layer"]);
        const prioritizedBaseProperties = prioritizeMandatoryProperties(transformedBaseProperties, mandatoryFirstProperties);

        return prioritizedBaseProperties;
    }

    return (
        <>
            <ItemCreate
                isModelOpen={isCreateModalOpen}
                record={serializeRecordForCreate()}
                onCloseModal={onCreateModalClose}
                onCreationSuccess={onCreationSuccess}
            />
            <ItemEdit
                isModelOpen={isEditModalOpen}
                record={itemToEdit}
                onCloseModal={onEditModalClose}
            />
        </>)
}

export default ItemCreateEdit;